jQuery(document).ready(function($) {
  
	$('.entry-attorney-text-inner').matchHeight();
	
	$('#homepage-slider .owl-carousel').owlCarousel({
		loop:true,
		mouseDrag:false,
		touchDrag:false,
		margin:0,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:false,
		nav:false,
		animateOut: 'fadeOut',
		responsive:{
			0:{
				items:1
			},
			1000:{
				items:1
			}
		}
	});
	
  

  if( $('#attorney-slider .owl-carousel').length ){
    var attorney_slider = $('#attorney-slider .owl-carousel');
    var startPosition = Math.floor(Math.random() * ($('.item', attorney_slider).length - 1)) + 1;
    
    attorney_slider.owlCarousel({
      loop:true,
      margin:0,
      nav:true,
	  navText: [
		`<svg width="17" height="31" viewBox="0 0 17 31" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0.90625 16.3438C0.484375 15.9219 0.484375 15.1484 0.90625 14.7266L14.4062 1.22656C14.8281 0.804688 15.6016 0.804688 16.0234 1.22656C16.4453 1.64844 16.4453 2.42188 16.0234 2.84375L3.29688 15.5L16.0234 28.2266C16.4453 28.6484 16.4453 29.4219 16.0234 29.8438C15.6016 30.2656 14.8281 30.2656 14.4062 29.8438L0.90625 16.3438Z" fill="#707272"/>
		</svg>`,
		`<svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M15.5234 14.7266C15.9453 15.1484 15.9453 15.9219 15.5234 16.3438L2.02344 29.8438C1.60156 30.2656 0.828125 30.2656 0.40625 29.8438C-0.015625 29.4219 -0.015625 28.6484 0.40625 28.2266L13.1328 15.5L0.40625 2.84375C-0.015625 2.42188 -0.015625 1.64844 0.40625 1.22656C0.828125 0.804688 1.60156 0.804688 2.02344 1.22656L15.5234 14.7266Z" fill="#707272"/>
		</svg>`
	  ],
      responsive:{
        0:{
          items:1
        },
        1000:{
          items:1
        }
      },
      startPosition: startPosition
    });
  }
	
	var owl = $('#homepage-slider .owl-carousel');
	owl.owlCarousel();
	
	$('.play-pause-slider').on('click', function(e){
		e.preventDefault();
		var $this = $(this);
		if($this.hasClass('paused')) {
			owl.trigger('next.owl.carousel');
			owl.trigger('play.owl.autoplay');
			$this.removeClass('paused');
		} else {
			$this.addClass('paused');
			owl.trigger('stop.owl.autoplay');
		}
	});
	
	$('.arrowdown').click(function(e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $(".homepage-main-content").offset().top
		}, 1500);
	});
	
	$(window).load(function(){
		if( $(window).width() >= 1024 && $('#homepage-slider').length ) {
			var hh = $('#header').height();
			var wh = $(window).height();
			$('#homepage-slider .owl-carousel .item').css({
				'min-height' : (wh-hh)+'px'
			});
		}
	});
  
  function alertBarPadding(){
    var alertBar = $('#alert-header');
    if(alertBar.length){
      $('body').css('padding-top', alertBar.outerHeight() );
    }
  }
  alertBarPadding();
  $(window).on('load resize',function(){
    alertBarPadding();
  });


	$('.select-link').on('change', function(){
		let url = $(this).val(); // get selected value
		if (url) { // require a URL
			window.location = url; // redirect
		}
		return false;
	});

	$('.filter-bar-attorney select').on('change', function(){
		$(this).closest('form').submit();
	});
	
	$('select').on('selectric-init', function(element){
		$(this).closest('.selectric-wrapper').find('.selectric-input').attr('title', 'Make a selection');
	});
	
	$('#nav .sf-menu > li > a').each(function(){
		$(this).attr('data-text', $(this).text());
	});

},jQuery());